import { Button as WSC_Button, ButtonProps as WSC_ButtonProps } from '@trackman/web-shared-components';
import React from 'react';
import styled, { css } from 'styled-components';

type CustomIntent = WSC_ButtonProps['intent'] | 'default';

type ButtonProps = Omit<WSC_ButtonProps, 'intent'> & {
  intent?: CustomIntent;
};

const StyledButton = styled(WSC_Button)<{ $customIntent?: CustomIntent }>`
  &&& {
    :active,
    &:focus {
      outline: none;
    }

    ${(props) =>
      props.$customIntent === 'default' &&
      css`
        background-color: #f5f5f5;
        color: #414141;

        &:hover {
          box-shadow: none;
          opacity: 1;

          &::before {
            background-color: #a0a0a0;
            opacity: 0.2;
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 4px;
          }
        }

        &:disabled {
          opacity: 0.5;
        }

        &
      `}
  }
`;

/**
 * TODO Remove this component when \@trackman/web-shared-components supports 'default' intent (> v3.0.0)
 */

export const Button: React.FC<ButtonProps> = (props) => {
  const { intent, ...rest } = props;

  return <StyledButton {...rest} intent={intent as WSC_ButtonProps['intent']} $customIntent={intent} />;
};
